import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '*', name: '/404', component: () => import('../views/404.vue') },
  { path: '/', redirect: 'login' },
  { path: '/login', name: 'login', component: () => import('../views/Login.vue') },
  { path: '/bim', name: 'bim', component: () => import('../views/BIM/Index.vue') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 添加路由守卫
// router.beforeEach((to, from, next) => {
//   const isLogin = !!localStorage.eleToken
//   if (to.path === '/login'||to.path === '/modelshare') {
//     next()
//   } else {
//     if (isLogin) {
//       // 判断是否选择了项目
//       const isProject = !!localStorage.eleProjectId
//       if (to.path === '/project') {
//         next()
//       } else {
//         isProject ? next() : next('/project')
//       }
//     } else {
//       next('/login')
//     }
//     // isLogin ? next() : next('/login')
//   }
// })
// 解决路由下的界面，点击该路由多次时
// 报错：NavigationDuplicated{_name: "NavigationDuplicated", name: "NavigationDuplicated", message: "Navigating to current location ("/one") is not allowed", stack: "Error↵    at new NavigationDuplicated (webpack-int…e_modules/element-ui/lib/mixins/emitter.js:29:22)"}
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
